import React, { useState } from "react";
import { Link } from "react-router-dom";
import google from "../../Assets/Logo/gooleLogo.png";
import facebook from "../../Assets/Logo/facebookLogo.png";
import Sharingan from "../ItachiEyePassword/itachiEyePassword";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../Components/AppProvider";
import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

import Modal from "./Modal/Modal";
import SendOTP from "./Modal/SendOTP";
import ForgotPass from "./Modal/ForgotPass";
import SendOTP2 from "./Modal/SendOTP2";
import ChangePassword from "./Modal/ChangePassword";

function LPLoginForm() {
  const { setHasBagCount, setIsLogin, setProfileChecker } = useAppContext();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [emailForForgot, setEmailForForgot] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const handleSharinganClick = () => {
    setShowPassword((prev) => !prev);
  };

  // Simple email validation function
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // ✅ Get Google user info
        const userInfoResponse = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          },
        );

        const user = await userInfoResponse.json();

        // ✅ Send to your backend for login/register
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/auth/google`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              provider: "google", // ✅ add this
              providerId: user.sub, // ✅ rename this
              firstname: user.given_name,
              lastname: user.family_name,
              email: user.email,
              profilePic: user.picture, // ✅ match backend variable name
            }),
          },
        );

        const data = await response.json();

        if (!response.ok) {
          alert(data.error || "Google login failed. Please try again.");
          return;
        }

        // ✅ Same success behavior as handleSubmit()
        alert("✅ Login successful!");

        const redirectStateRaw = localStorage.getItem("redirectAfterLogin");
        const redirectState = redirectStateRaw
          ? JSON.parse(redirectStateRaw)
          : null;

        console.log("redirectState", redirectState);

        if (redirectState?.path) {
          const { path, scrollTop, productId } = redirectState;
          console.log("Redirecting to:", path);
          navigate(path);

          requestAnimationFrame(() => {
            window.scrollTo(0, scrollTop || 0);

            if (productId) {
              const event = new CustomEvent("openProductModal", {
                detail: { productId },
              });
              window.dispatchEvent(event);
            }
          });
        } else {
          localStorage.setItem(
            "redirect",
            JSON.stringify({
              nav: 0,
              side: 0,
            }),
          );
          navigate("/customer-profile?nav=0&side=0");
        }

        setHasBagCount(true); // Ensure AppContext refreshes profile immediately after login
        setIsLogin(true);
        setProfileChecker((prev) => !prev);
      } catch (err) {
        console.error("Google login error:", err);
        alert("Network error. Please try again later.");
      }
    },
    onError: (error) => {
      console.error("❌ Google Login Failed:", error);
      alert("Google login failed. Please try again.");
    },
  });

  const [isModalOpen, setModalOpen] = useState("");
  const handeLogin = async () => {
    let newErrors = {};

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email, password }),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        /*
        setErrors({
          general: data.error || "Login failed. Please try again.",
        });*/
        alert(data.error || "Login failed. Please try again.");
      } else {
        setModalOpen("OTP"); // open modal
      }
    } catch (error) {
      console.error(error);
      setErrors({ general: "Network error. Please try again later." });
    }
  };

  return (
    <>
      <div className="lp-login-panel">
        <div className="lp-login-form">
          {/* General error */}
          <div className="lp-validation-error-general-wrapper">
            {errors.general && (
              <div className="lp-validation-error">{errors.general}</div>
            )}
          </div>
          {/* Email input */}
          <div className="lp-login-input-wrapper lp-username">
            <input
              type="text"
              className={`lp-login-input ${errors.email ? "input-error" : ""} ${
                email ? "has-value" : ""
              }`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required={true}
            />
            <label className="lp-floating-label">EMAIL ADDRESS</label>
          </div>
          <div className="lp-validation-error-wrapper">
            {errors.email && (
              <div className="lp-validation-error">{errors.email}</div>
            )}
          </div>

          {/* Password input */}
          <div className="lp-login-input-wrapper lp-password">
            <input
              id="password"
              name="password"
              style={{
                fontFamily: showPassword
                  ? "comica, cursive"
                  : "Courier New, monospace",
                padding: showPassword ? "10px 50px" : undefined,
              }}
              type={showPassword ? "text" : "password"}
              className={`lp-login-input ${
                errors.password ? "input-error" : ""
              } ${password ? "has-value" : ""}`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required={true}
            />
            <label htmlFor="password" className="lp-floating-label">
              PASSWORD
            </label>
            <Sharingan onLoginClick={handleSharinganClick} />
          </div>

          <div className="lp-validation-error-wrapper">
            {errors.password && (
              <div className="lp-validation-error">{errors.password}</div>
            )}
          </div>

          {/* Forgot password link */}
          <div className="forgotpass-wrapper">
            <span
              onClick={() => {
                setModalOpen("Forgot");
              }}
            >
              FORGOT PASSWORD
            </span>
          </div>

          {/* Button triggers custom validation */}
          <button
            type="button"
            className="lp-login-button"
            onClick={handeLogin}
            //onClick={handleSubmit}
          >
            LOG IN
          </button>

          {/* OR section */}
          <div className="lp-orSignWith">
            <br />
            <p>OR</p>
            <p>SIGN IN WITH</p>
          </div>

          {/* Social logins */}
          {/* Google Login */}
          <div className="lp-login-using using-google">
            {/** 
          <a
            onClick={() => (window.location.href = "https://www.facebook.com")}
            className="lp-login-using-buttons using-facebook"
            href="#!"
          >
            <div className="facebook-logo-wrapper">
              <img
                src={facebook}
                className="facebook-logo"
                alt="Facebook Logo"
              />
            </div>
          </a>
*/}
            <button
              onClick={googleLogin}
              className="lp-login-using-buttons using-google"
              href="#!"
            >
              <div className="google-logo-wrapper">
                <img src={google} className="google-logo" alt="Google Logo" />
              </div>
            </button>
          </div>
        </div>
      </div>
      <Modal isModalOpen={isModalOpen} onClose={() => setModalOpen(false)}>
        {isModalOpen === "OTP" ? (
          <SendOTP
            email={email}
            onSuccess={(data) => {
              //console.log("✅ Logged in user:", data.user);
              navigate("/customer-profile");
              setHasBagCount(true);
            }}
            onClose={() => setModalOpen(false)}
          />
        ) : isModalOpen === "Forgot" ? (
          <ForgotPass
            setModalOpen={setModalOpen}
            setEmailForForgot={setEmailForForgot}
            emailForForgot={emailForForgot}
          />
        ) : isModalOpen === "OTP2" ? (
          <SendOTP2
            emailForForgot={emailForForgot}
            setModalOpen={setModalOpen}
            onClose={() => setModalOpen(false)}
          />
        ) : isModalOpen === "ChangePass" ? (
          <ChangePassword
            setModalOpen={setModalOpen}
            setEmailForForgot={setEmailForForgot}
            emailForForgot={emailForForgot}
          />
        ) : (
          ""
        )}
      </Modal>
    </>
  );
}

export default LPLoginForm;
